import React, { forwardRef, useEffect, useState } from "react";
import './StructureSection.css';

const StructureSection = forwardRef(({ scrollToNextSection }, ref) =>  {
  const [opacity, setOpacity] = useState(1);
  const [isScrolling, setIsScrolling] = useState(false);

  const [estrutura,setEstrutura]=useState([]);

  useEffect(() => {
    // Caminho para o JSON dentro da pasta public
    fetch('/assets/json/estrutura.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro ao carregar o arquivo JSON');
        }
        return response.json();
      })
      .then((jsonData) => {
        setEstrutura(jsonData);
      })
      .catch((error) => {
        console.error('Erro ao buscar o arquivo JSON:', error);
      });
  }, []);

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      setIsScrolling(true);

      // Limpa o temporizador anterior se houver
      clearTimeout(timeoutId);

      // Configura um temporizador para iniciar a transição de opacidade após a rolagem parar
      timeoutId = setTimeout(() => {
        setOpacity(0); // Começa a desaparecer gradativamente
      }, 10); // Inicia a transição de opacidade após 100ms

      // Configura um temporizador para restaurar a opacidade após a rolagem parar
      timeoutId = setTimeout(() => {
        setOpacity(1); // Restaura a opacidade
        setIsScrolling(false);
      }, 200); // Tempo para restaurar a opacidade após 1 segundo de inatividade
    };

    // Adiciona o ouvinte de evento de rolagem
    window.addEventListener('scroll', handleScroll);

    // Remove o ouvinte de evento quando o componente é desmontado
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  useEffect(() => {
    const handleScroll = () => {
      const parallax = document.getElementById('planta');
      const scrolled = window.scrollY;
      parallax.style.transform = `translateY(${(scrolled * 0.1) - (-10)}px)`; // Ajuste a velocidade do efeito
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section id={"structure-section"} className="structure-section" ref={ref}>
        <div className="content">
          
            <div className="content-header">
              <h2>ESTRUTURA</h2>
              <p>Bem ventilado, com iluminação natural e excelente estrutura de apoio, o estúdio se adapta a diferentes tipos de produção e acomoda equipes de até 15 pessoas. <span>Confira:</span></p>
            </div>
            <div className="content-body">
              <ul>
                {
                  estrutura.map((data,key)=>{
                    return(
                      <li>{data}</li>
                    )
                  })
                }
              </ul>
              <a target={"_blank"} href={'https://wa.me/5511950742962'} id="fale"><i className="fa fa-phone"></i><span> | FALE COM A GENTE</span></a>
            </div>
        </div>
        <img id="planta" src="/assets/img/Planta.png"/>
        <div className="transaction">
              <button onClick={scrollToNextSection} style={{
          opacity,
          transition: 'opacity 0.2s ease' // Animação de transição de opacidade
        }}><span>SCROLL DOWN</span><img src="/assets/icons/angle-down.png"/></button>
            </div>
    </section>
  );
});

export default StructureSection;
